import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/test.environment';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

export interface TimesheetEntry {
  date: string;
  employee: string;
  project: number;
  workCode: string;
  jobType: string | null;
  hours: number;
}

export interface WorkCode {
  code: string;
  description: string;
  displayOrder: number;
}

export interface JobType {
  code: string;
  description: string;
  displayOrder: number;
}

@Injectable({ providedIn: 'root' })
export class TimesheetService {
  constructor(private http: HttpClient) {}

  getTimesheetByProject(projectNumber: number): Observable<TimesheetEntry[]> {
    return this.http.get<TimesheetEntry[]>(`${environment.apiBaseUrl}/api/timesheets/project/${projectNumber}`);
  }

  getWorkCodes(): Observable<WorkCode[]> {
    return this.http.get<WorkCode[]>(`${environment.apiBaseUrl}/api/timesheets/work-codes`);
  }

  addTimesheetEntry(entry: TimesheetEntry): Observable<TimesheetEntry> {
    return this.http.post<TimesheetEntry>(`${environment.apiBaseUrl}/api/timesheets/entry`, entry);
  }

  updateTimesheetEntry(entry: TimesheetEntry): Observable<TimesheetEntry> {
    return this.http.put<TimesheetEntry>(`${environment.apiBaseUrl}/api/timesheets/entry`, entry);
  }

  deleteTimesheetEntry(entry: TimesheetEntry): Observable<any> {
    // Backend handles upsert/delete via POST /entry when hours == 0.
    // Redirect delete calls to the POST upsert endpoint to avoid DELETE 405 errors.
    const entryForDelete = { ...entry, hours: 0 } as TimesheetEntry;
    return this.addTimesheetEntry(entryForDelete);
  }

  // Fallback: some backends expect DELETE with a JSON body instead of query params
  deleteTimesheetEntryWithBody(entry: TimesheetEntry): Observable<any> {
    return this.http.request('delete', `${environment.apiBaseUrl}/api/timesheets/entry`, { body: entry });
  }

  // Additional fallbacks: some APIs expose delete via POST endpoints
  deleteTimesheetEntryViaPost(entry: TimesheetEntry): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/api/timesheets/entry/delete`, entry);
  }

  deleteTimesheetEntryViaPostAlt(entry: TimesheetEntry): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/api/timesheets/delete`, entry);
  }
}